import { createFileRoute } from "@tanstack/react-router";
import EmailLinkPage from "@/site/pages/email-link";

/**
 * `/email-link#t=<token>` — the button in a verify / password-reset email (BDAY-479). The
 * token is in the FRAGMENT on purpose (never sent to a server, so never in logs or Referer);
 * the page reads it, strips it from the address bar and POSTs it. No search params.
 */
export const Route = createFileRoute("/email-link")({
  component: EmailLinkPage,
});
